// --- Core ---
import {reduce} from "underscore";
// --- Material UI ---
import {styled} from "@mui/material/styles";

/** Join Array of Objects similar to String.prototype.join with a separator
 *
 * @param objects Array of objects (e.g. React nodes) to be joined
 * @param separator Separator inserted between elements. Default: ','
 */
export const joinObjects = (objects, separator = ', ') =>
  reduce(objects, (memo, value) => [memo, separator, value]);

export const Image = styled('img', {shouldForwardProp: prop => prop === 'alt' || prop === 'height' || prop === 'width' || prop === 'src'})();
